import { useEffect } from "react";
import { ProjetosFormInicial } from "src/components/projetos/FormInicial";
import { appStore } from "src/framework/store/AppStore";
import { EdicaoLayout } from "src/components/projetos/edicao/layouts/EdicaoLayout";

const PAGE_TITLE = 'Clonar projeto'

const ProjetosFormInicialClonarPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])
  
  return (
    <EdicaoLayout clonarProjeto={true}>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicial />
          </div>
        </div>
      </div>
    </EdicaoLayout>
  );
};

export { ProjetosFormInicialClonarPage };